import { fileToUrl } from "@/content/ContentContext";

export default function Vision({ content }) {
  const c = content || {};
  const stats = c.stats || [];
  return (
    <section
      id="vision"
      data-testid="vision-section"
      className="relative py-24 md:py-36 lg:py-44 bg-[var(--bone)]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 reveal">
          <div className="relative">
            <img
              src={fileToUrl(c.image_url)}
              alt="Heritage main street"
              className="w-full h-[420px] md:h-[520px] object-cover"
            />
            <div className="absolute -bottom-6 -right-6 bg-[var(--bone-2)] px-6 py-4 hidden md:block">
              <p className="overline">Est. Heritage District</p>
              <p className="font-serif-display text-2xl mt-1">Meaford, ON</p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 reveal">
          <p className="overline mb-6" data-testid="vision-overline">
            {c.overline}
          </p>
          <h2
            data-testid="vision-title"
            className="font-serif-display text-3xl md:text-4xl lg:text-5xl leading-[1.15] tracking-tight font-medium"
          >
            {c.title}
          </h2>
          <div className="mt-8 space-y-5 text-[var(--ink-soft)] text-base md:text-lg leading-relaxed max-w-xl">
            {c.body_1 && <p data-testid="vision-body-1">{c.body_1}</p>}
            {c.body_2 && <p data-testid="vision-body-2">{c.body_2}</p>}
          </div>

          {stats.length > 0 && (
            <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 max-w-xl">
              {stats.map((s, i) => (
                <div key={i}>
                  <p className="font-serif-display text-3xl md:text-4xl">{s.value}</p>
                  <p className="overline mt-2">{s.label}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
